module.exports = __webpack_public_path__ + "static/media/univers-beaute.6fd4382e.png";